<template>
	<div :ref="`card-${provider.slug}`" class="integration-wrap" :class="wrapClasses">
		<!-- Integration Card -->
		<div class="omapi-card__flex">
			<integrations-integration-card :provider="provider" />
		</div>
		<common-transition-slide
			:active="isActive"
			:is-absolute="true"
			:duration="300"
			@opened="opened = true"
			@close-start="opened = false"
		>
			<integrations-expandable-content
				v-show="isActive"
				:hidden="false"
				:class="{ active: opened }"
				:provider="provider"
			>
				<!-- Exiting Integrations -->
				<div v-if="showIntegrations" class="existing-integrations-wrap">
					<integrations-forms-uncanny-automator v-if="isUncannyAutomator" :provider="provider" />
					<template v-else>
						<integrations-integration-row
							v-for="integration in provider.integrations"
							:key="integration.id"
							:integration="integration"
							:legacy="isLegacy"
						/>
						<div v-if="canCreate" class="omapi-integration-cta">
							<core-button color="green" @click="handleConnect"> Add a New Connection </core-button>
						</div>
					</template>
				</div>
				<!-- Provider Form -->
				<integrations-form v-if="showForm" :provider="provider" />
			</integrations-expandable-content>
		</common-transition-slide>
		<!-- Delete Integration Modal -->
		<integrations-modal-delete
			v-for="integration in provider.integrations"
			:key="integration.id"
			:integration="integration"
		/>
		<!-- No Access Modal -->
		<integrations-modal-no-access :provider="provider" />
	</div>
</template>
<script>
import { integration } from '@/integrations/mixins/integration';
import { filtering } from '@/integrations/mixins/filtering';
import { form } from '@/integrations/mixins/form';
import { scrolltoref } from '@/components/mixins/scrolltoref';
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapMutations } = createNamespacedHelpers('integrations');

export default {
	mixins: [integration, filtering, form, scrolltoref],
	props: {
		/**
		 * Provider
		 */
		provider: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			opened: false,
		};
	},
	computed: {
		...mapState(['activeContent', 'filters', 'search']),
		/**
		 * Should Show
		 *
		 * @since 2.4.0
		 *
		 * @returns {boolean} Can this provider be shown?
		 */
		shouldShow() {
			// User and featured integrations are always visible.
			if (this.provider.canBypass || this.isFeatured || this.hasIntegrations) {
				return true;
			}

			return this.isVisible(this.provider.name, this.provider.supports.categories);
		},
		/**
		 * Wrap Classes
		 *
		 * @since 2.4.0
		 *
		 * @returns {string} The classes.
		 */
		wrapClasses() {
			return {
				'om-hide': !this.shouldShow,
				[this.provider.slug]: true,
			};
		},
	},
	watch: {
		opened(val) {
			if (val) {
				this.$bus.$emit('integrationOpened', this.provider.slug);
			}
		},
		/**
		 * Watch: Should Show
		 *
		 * @since 2.4.0
		 *
		 * @param {boolean} isVisible Is this provider visible?
		 *
		 * @returns {void}
		 */
		shouldShow(isVisible) {
			// Let's keep track of which providers are in the search results.
			// When this provider's visiblity changes, add or remove it
			// depending on the value.
			if (isVisible && !this.isFeatured && !this.hasIntegrations) {
				this.addToSearchResults(this.provider.slug);
			} else {
				this.removeFromSearchResults(this.provider.slug);
			}
		},
	},
	methods: {
		...mapMutations(['addToSearchResults', 'removeFromSearchResults']),
	},
};
</script>
